import { getCurrentInstance, SetupContext, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import { FeedLiked, Feed } from '@/api/feed';
import { FeedPageEnum } from '@/store/modules/feed';
import { ActionType, ActionBarProps } from './common';
import { radarLog } from '@/common/radar';
import { compareVersion, formateNum } from '~/common/utils';
import { PwaBridge } from '@/common/bridge';

export const ActionBarAppSetup = (props: ActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    // const baseSetup = ActionBarBaseSetup(props, ctx);
    const { proxy } = getCurrentInstance() || {};
    // const { feedList } = baseSetup || {};

    const feedList = computed<Feed[]>(() => {
        const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
        return feedListOrigin?.[props?.feedPage || FeedPageEnum.PwaShareNew] || [];
    });

    const handleLikeAction = debounce(async (type: ActionType) => {
        const feedLikeStatus = type === ActionType.Like ? FeedLiked.Like : FeedLiked.UnLike;

        const newFeedList = feedList.value?.map?.(feed => {
            if (feed.photo_id_str === props?.photoId) {
                return {
                    ...feed,
                    liked: feedLikeStatus,
                };
            }
            return feed;
        });
        proxy?.$store?.commit?.('feedMoudle/resetFeedList', props.feedPage);
        proxy?.$store?.commit?.('feedMoudle/setFeedList', {
            [props?.feedPage || FeedPageEnum.PwaShareNew]: newFeedList || [],
        });
    }, 300);

    /**
     * @zh “举报”按钮点击
     * @zh feature：仅上报埋点
     */
    const handleReport = () => {
        radarLog({
            name: 'PWA_REPORT_APP',
        });
        Toast({
            message: proxy?.$root?.$t?.('report_successful_toast'),
            duration: 1500,
        });
    };

    const handleDownloadAction = debounce(async () => {
        // ctx.emit('sendActionRecoLog', 'PWA_DOWNLOAD_PHOTO');
        try {
            const currentFeed = feedList.value?.find(item => item.photo_id_str === props?.photoId);
            const videoUrl = currentFeed?.main_mv_urls?.find?.(mv => !!mv.url)?.url;

            if (!videoUrl) {
                return;
            }

            const res = await PwaBridge.saveMediaToAlbum({
                url: videoUrl,
                mediaType: 'video',
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, 300);

    const likeCount = (count: number) => {
        const appVersion = proxy?.$appConfig?.appver;
        // 这里做版控原因
        // 互动数的展示需要先通过Google Play的审核，因此限制即将提审的版本1.8.2显示互动数
        // 后面当GP过审后，再改动代码，所有版本都显示互动数
        // todo @jinyao
        if (appVersion && compareVersion(appVersion, '1.8.2') >= 0) {
            return formateNum(count || 0).toString();
        }

        return (proxy?.$root?.$t('k_344306') || '') as string;
    };

    const commentCount = (count: number) => {
        const appVersion = proxy?.$appConfig?.appver;
        // 这里做版控原因
        // 互动数的展示需要先通过Google Play的审核，因此限制即将提审的版本1.8.2显示互动数
        // 后面当GP过审后，再改动代码，所有版本都显示互动数
        // todo @jinyao
        if (appVersion && compareVersion(appVersion, '1.8.2') >= 0) {
            return formateNum(count || 0).toString();
        }

        return (proxy?.$root?.$t('k_467898') || '') as string;
    };

    const shareCount = (count: number) => {
        const appVersion = proxy?.$appConfig?.appver;
        // 这里做版控原因
        // 互动数的展示需要先通过Google Play的审核，因此限制即将提审的版本1.8.2显示互动数
        // 后面当GP过审后，再改动代码，所有版本都显示互动数
        // todo @jinyao
        if (appVersion && compareVersion(appVersion, '1.8.2') >= 0) {
            return formateNum(count || 0).toString();
        }

        return 'Share';
    };

    return {
        handleLikeAction,
        handleDownloadAction,

        handleReport,
        likeCount,
        commentCount,
        shareCount,
    };
};
